import mainImg1 from 'assets/images/main/visual1.png';
import mainImg3 from 'assets/images/main/visual3.png';

import business1 from 'assets/images/main/business_1.jpg';
import business2 from 'assets/images/main/business_2.jpg';
import business3 from 'assets/images/main/business_3.jpg';
import business4 from 'assets/images/main/business_4.jpg';

import product1 from 'assets/images/product/product1.png';
import productD from 'assets/images/product/product_d.png';

export const krMain = {
  visual: mainImg1,
  visualSlide: [
    {
      img: mainImg1,
      title: `Humanism이 살아있는 환경 기술`,
      desc: `주식회사 팜인은 환경과 공존하는 축산 기술, 동물 복지 구현과 휴머니즘 서비스를 제공하는 기업입니다.`,
    },
    {
      img: mainImg3,
      title: `Humanism이 살아있는 환경 기술`,
      desc: `주식회사 팜인은 환경과 공존하는 축산 기술, 동물 복지 구현과 휴머니즘 서비스를 제공하는 기업입니다.`,
    },
  ],
  businessTitle: `BUSINESS`,
  businessContent: [
    {
      img: business1,
      title: `ECO FRIENDLY`,
      subject: '환경과 공존하는 사업',
      desc: `환경과 공존하는 축산 산업의\n악취로부터 자유로운 환경을\n만들기 위해 지속 가능한\n시스템 구축`,
    },
    {
      img: business2,
      title: `ANIMAL\nWELFARE`,
      subject: '동물 복지 구현',
      desc: `동물 복지 환경을 조성하여\n질병 및 스트레스를 최소화함에\n따른 동물 삶의 질 향상`,
    },
    {
      img: business3,
      title: `HUMANISM\nSERVICE`,
      subject: '휴머니즘 서비스',
      desc: `건강하고 안전한 축산 제품으로\n안심 먹거리 제공`,
    },
    {
      img: business4,
      title: `BUSINESS`,
      subject: '비즈니스 내용',
      desc: `환경과 공존하여 지속 가능한\n가치 창출을 목표로 하는기업
      `,
    },
  ],
  specialityTitle: `SPECIALITY`,
  specialityContent: [
    {
      name: 'speciality1',
      width: 120,
      tWidth: 90,
      mWidth: 65,
      subject: `고이온화 및 수분 흡착\n기반 필터 없는 악취 제거\n기술`,
    },
    {
      name: 'speciality2',
      width: 120,
      tWidth: 90,
      mWidth: 65,
      subject: `정전기력 기반\n악취 포집 기술`,
    },
    {
      name: 'speciality3',
      width: 105,
      tWidth: 79,
      mWidth: 57,
      subject: `악취모니터링 및\n통합플랫폼 기술`,
    },
  ],
  productTitle: `PRODUCT`,
  productContent: [
    {
      id: 1,
      img: productD,
      title: `AeroQbit-D`,
      desc: `축사용 제습기.`,
    },
    {
      id: 2,
      img: product1,
      title: `AeroQbit-A`,
      desc: `내부 공기 순환.\n악취 저감 시스템.`,
    },
  ],
  communityTitle: `COMMUNITY`,
  communityContnet: [
    {
      id: 1,
      type: `NOTICE`,

      title: `공지사항 내용 공지사항 내용공지사항 내용 공지사항 내용 공지사항 내용 공지사항 내용 공지사항 내용 공지사항 내용 공지사항 내용 공지사항 내용 공지사항 내용 공지사항 내용`,
      createDate: `2099.99.99`,
    },
    { id: 2, type: `NOTICE`, title: `공지사항 내용`, createDate: `2099.99.99` },
    { id: 3, type: `NOTICE`, title: `공지사항 내용`, createDate: `2099.99.99` },
    { id: 4, type: `NOTICE`, title: `공지사항 내용`, createDate: `2099.99.99` },
  ],
  communityContnetQna: [
    {
      id: 1,
      type: `QNA`,
      userName: '작성자',
      title: `공지사항 내용 공지사항 내용공지사항 내용 공지사항 내용 공지사항 내용 공지사항 내용 공지사항 내용 공지사항 내용 공지사항 내용 공지사항 내용 공지사항 내용 공지사항 내용`,
      isPassword: '1234',
      createDate: `2099.99.99`,
    },
    { id: 2, type: `QNA`, userName: '작성자', title: `공지사항 내용`, isPassword: '1234', createDate: `2099.99.99` },
    { id: 3, type: `QNA`, userName: '작성자', title: `공지사항 내용`, isPassword: '1234', createDate: `2099.99.99` },
    { id: 4, type: `QNA`, userName: '작성자', title: `공지사항 내용`, isPassword: '1234', createDate: `2099.99.99` },
  ],
  communityContnetArchive: [
    {
      id: 1,
      type: `자료실`,
      attachedFile: 'test.jpg',
      attachedFileName: 'test.jpg',
      title: `자료실 내용 자료실 내용 자료실 내용 자료실 내용 자료실 내용 자료실 내용 자료실 내용 자료실 내용 자료실 내용 자료실 내용 자료실 내용 자료실 내용 자료실 내용 `,
      createDate: `2099.99.99`,
    },
    {
      id: 2,
      type: `자료실`,
      attachedFile: 'test.jpg',
      attachedFileName: 'test.jpg',
      title: `자료실 내용`,
      createDate: `2099.99.99`,
    },
    {
      id: 3,
      type: `자료실`,
      attachedFile: 'test.jpg',
      attachedFileName: 'test.jpg',
      title: `자료실 내용`,
      createDate: `2099.99.99`,
    },
    {
      id: 4,
      type: `자료실`,
      attachedFile: 'test.jpg',
      attachedFileName: 'test.jpg',
      title: `자료실 내용`,
      createDate: `2099.99.99`,
    },
  ],
};

export const enMain = {
  visual: mainImg1,
  visualSlide: [
    {
      img: mainImg1,
      title: `Humanism이 살아있는 환경 기술`,
      desc: `주식회사 팜인은 환경과 공존하는 축산 기술, 동물 복지 구현과 휴머니즘 서비스를 제공하는 기업입니다.`,
    },
    {
      img: mainImg1,
      title: `Humanism이 살아있는 환경 기술`,
      desc: `주식회사 팜인은 환경과 공존하는 축산 기술, 동물 복지 구현과 휴머니즘 서비스를 제공하는 기업입니다.`,
    },
  ],
  businessTitle: `BUSINESS_EN`,
  businessContent: [
    {
      img: business1,
      title: `ECO FRIENDLY_EN`,
      subject: '환경과 공존하는 사업',
      desc: `환경과 공존하는 축산 산업의\n악취로부터 자유로운 환경을\n만들기 위해 지속 가능한\n시스템 구축`,
    },
    {
      img: business2,
      title: `ANIMAL\nWELFARE_EN`,
      subject: '동물 복지 구현',
      desc: `동물 복지 환경을 조성하여\n질병 및 스트레스를 최소화함에\n따른 동물 삶의 질 향상`,
    },
    {
      img: business3,
      title: `HUMANISM\nSERVICE_EN`,
      subject: '휴머니즘 서비스',
      desc: `건강하고 안전한 축산 제품으로\n안심 먹거리 제공`,
    },
    {
      img: business4,
      title: `BUSINESS_EN`,
      subject: '비즈니스 내용',
      desc: `환경과 공존하여 지속 가능한\n가치 창출을 목표로 하는기업
      `,
    },
  ],
  specialityTitle: `SPECIALITY_EN`,
  specialityContent: [
    {
      name: 'speciality1',
      width: 120,
      tWidth: 90,
      mWidth: 65,
      title: `기술소개`,
      subject: `팜인만의 특별한 기술 첫번째.\n내용은 간결하고 단순하게.`,
    },
    {
      name: 'speciality2',
      width: 120,
      tWidth: 90,
      mWidth: 65,
      title: `기술소개`,
      subject: `팜인만의 특별한 기술 두번째`,
    },
    {
      name: 'speciality3',
      width: 105,
      tWidth: 79,
      mWidth: 57,
      title: `기술소개`,
      subject: `팜인만의 특별한 기술 세번째`,
    },
  ],
  productTitle: `PRODUCT_EN`,
  productContent: [
    {
      id: 1,
      img: productD,
      title: `AeroQbit-D`,
      desc: `축사용 제습기.`,
    },
    {
      id: 2,
      img: product1,
      title: `AeroQbit-A`,
      desc: `내부 공기 순환.\n악취 저감 시스템.`,
    },
  ],
  communityTitle: `COMMUNITY_EN`,
  communityContnet: [
    {
      id: 1,
      type: `NOTICE`,
      title: `공지사항 내용 공지사항 내용공지사항 내용 공지사항 내용 공지사항 내용 공지사항 내용 공지사항 내용 공지사항 내용 공지사항 내용 공지사항 내용 공지사항 내용 공지사항 내용`,
      isPassword: '1234',
      createDate: `2099.99.99`,
    },
    { id: 2, type: `NOTICE`, title: `공지사항 내용`, isPassword: '1234', createDate: `2099.99.99` },
    { id: 3, type: `NOTICE`, title: `공지사항 내용`, isPassword: '1234', createDate: `2099.99.99` },
    { id: 4, type: `NOTICE`, title: `공지사항 내용`, isPassword: '1234', createDate: `2099.99.99` },
  ],
};
